import React from "react";
import { Link, useParams } from "react-router-dom";

// third-party
import ScrollAnimation from "react-animate-on-scroll";

// project-imports
import SectionTitle from "../sectionTitle/SectionTitle";
import { useProductContext } from "../../context/product_context";
import ErrorComponent from "../error-message/ErrorComponent";
import {
  GoogleAnalyticsEnum,
  triggerFunction,
} from "../../utils/google-analytics";
import TrainingProgramsTwo from "../training-programs/TrainingProgramsTwo";
import TrainingProgramTwoStencil from "../training-programs/TrainingProgramTwoStencil";
import TestimonialThree from "../testimonial/TestimonialThree";

const SalesforceOffering = () => {
  // Reading variables and methods from context
  const { products, productLoading, productsError } = useProductContext();

  // Property initialization
  const { productCode } = useParams();

  const internshipPrograms = (products || []).filter(
    (i) => i.type === "internship" && i.duration === "3 Months",
  );

  const flexLearningPrograms = (products || []).filter(
    (i) => i.type === "flex-learning-path" && i.duration === "2-3 Months",
  );

  const trainingPrograms = [...internshipPrograms, ...flexLearningPrograms];

  if (productLoading) {
    // Loading stencil
    return <TrainingProgramTwoStencil />;
  }

  return (
    <div className="edu-course-area eduvibe-home-one-blog bg-image edu-section-gap">
      <div className="container eduvibe-animated-shape">
        <div className="row">
          <div className="col-12 col-xl-6 mb--30">
            <div className="row">
              <div className="col-12">
                <SectionTitle
                  classes="text-left"
                  slogan="Let’s Learn Together"
                  title="Our Training Programs"
                />
              </div>
            </div>
            <div className="row g-5 mt--25">
              {!productLoading && productsError ? (
                <ErrorComponent
                  errorCode="500"
                  mainError="No Training Programs are available!"
                  subText="Currently we don't have training programs. Please be back later."
                  buttonText="Back to Home"
                  link="/"
                />

              ) : (!productLoading && !productsError && !trainingPrograms?.length) ? (
                <div className="col-12">
                  <ErrorComponent
                    errorCode="404"
                    mainError="Failed to get the training programs right now."
                    subText="Please return to the site's homepage, It looks like nothing was found at this location"
                    buttonText="Back to Home"
                    link="/"
                  />
                </div>
              ) : (
                <>
                  <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}
                    className="col-12 animate-fill-none "
                  // key={item.id}
                  >
                    {(trainingPrograms || [])?.slice(0, 3).map((item) => (
                      <TrainingProgramsTwo
                        data={item}
                        bgWhite="enable"
                        code={productCode}
                      />
                    ))}
                  </ScrollAnimation>
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <div className="row">
              <div className="col-12">
                <SectionTitle
                  classes="text-left"
                  slogan="user reviews"
                  title="Recent Reviews From Users"
                />
              </div>
            </div>
            <div className="row g-5 mt--25">
              <div className="col-12 p-0">
                <div
                  class="testimonial-activation animated fadeIn"
                // style="animation-duration: 1s;"
                >
                  <div class="testimonial-card-box">
                    {/* <TestimonialThree /> */}
                    <TestimonialThree arrows="enable" rating="disable" fade="disable" dots="false" details2="enable" className="edu-slick-button slick-button-left" itemClass="testimonial-card-box variation-3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-5 y-gap-15 justify-content-center">
          <div className="col-auto">
            <div className="load-more-btn">
              <Link className="button -icon -outline-purple-1 color-primary"
                to="our-offerings/salesforceAdmin"
                onClick={() =>
                  triggerFunction(
                    GoogleAnalyticsEnum.BUTTON,
                    GoogleAnalyticsEnum.SALESFORCE_ALL_TRAINING_PROGRAMS,
                  )
                }
              >
                View All Training Programs<i class="ri-arrow-right-up-line ml--10"></i>
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
          <div className="shape-image shape-image-1">
            <img src="/images/shapes/shape-03-07.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-2">
            <img src="/images/shapes/shape-02-04.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-3">
            <img src="/images/shapes/shape-05-02.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-4">
            <img src="/images/shapes/shape-13-05.png" alt="Shape Thumb" />
          </div>
          <div className="shape shape-1">
            <span className="shape-dot"></span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SalesforceOffering;
